// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// const Language = () => {
//   const [posts, setPosts] = useState([]);
//   const [input, setInput] = useState('en_US');
//   const [editId, setEditId] = useState(null);
//   const [editInput, setEditInput] = useState('');

//   const user = JSON.parse(sessionStorage.getItem('user')) || {};
//   const userId = user.id || '';
//   // const waId = user.wa_id || '';
//   const isAdmin = false;

//   const languageOptions = [
//     { code: 'en_US', name: 'English (en_US)' },
//     { code: 'hi_IN', name: 'Hindi (hi_IN)' },
//     { code: 'fr_FR', name: 'French (fr_FR)' },
//     { code: 'bn_IN', name: 'Bengali (bn_IN)' },
//     { code: 'ta_IN', name: 'Tamil (ta_IN)' },
//     { code: 'te_IN', name: 'Telugu (te_IN)' },
//     { code: 'mr_IN', name: 'Marathi (mr_IN)' },
//     { code: 'kn_IN', name: 'Kannada (kn_IN)' },
//     { code: 'gu_IN', name: 'Gujarati (gu_IN)' },
//     { code: 'ml_IN', name: 'Malayalam (ml_IN)' },
//     { code: 'pa_IN', name: 'Punjabi (pa_IN)' },
//     { code: 'ur_IN', name: 'Urdu (ur_IN)' },
//     { code: 'or_IN', name: 'Odia (or_IN)' },
//     { code: 'es_ES', name: 'Spanish (es_ES)' },
//     { code: 'de_DE', name: 'German (de_DE)' },
//     { code: 'zh_CN', name: 'Chinese (zh_CN)' },
//     { code: 'ja_JP', name: 'Japanese (ja_JP)' },
//     { code: 'ru_RU', name: 'Russian (ru_RU)' },
//     { code: 'ar_SA', name: 'Arabic (ar_SA)' },
//     { code: 'pt_PT', name: 'Portuguese (pt_PT)' },
//     { code: 'it_IT', name: 'Italian (it_IT)' },
//     { code: 'ko_KR', name: 'Korean (ko_KR)' },
//   ];

//   // waid get

  
//   const [waId, setWaId] = useState(null);
//   // const [userId, setUserId] = useState(null);
//   const [templateOptions, setTemplateOptions] = useState([]);
  
//   /* ---------------------------
//      1️⃣  GET WA_ID BASED ON ROLE
//   ----------------------------*/
//   useEffect(() => {
//     const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//     if (!loggedUser) return;
  
//     // ROLE-BASED EMAIL
//     const emailToUse =
//       loggedUser.role === "admin"
//         ? loggedUser.email         // admin → use own email
//         : loggedUser.adminEmail;   // member → use admin's email
  
//     if (!emailToUse) return;
  
//     axios
//       .get(
//         `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
//           emailToUse
//         )}`
//       )
//       .then((response) => {
//         const userData = response.data;
//         console.log("User Data Fetched:", userData);
  
//         if (userData?.wa_id) {
//           setWaId(userData.wa_id);
//         }
//       })
//       .catch((err) => {
//         console.error("Error retrieving user data:", err);
//       });
//   }, []);
  

//   useEffect(() => {
//     if (!userId) return;

//     const fetchPosts = async () => {

//       const storedUser = JSON.parse(sessionStorage.getItem('user'));

//     if (!storedUser) {
//       alert('User not logged in');
  
//       return;
//     }
//       const role = storedUser.role;
//     const member_id = role === "admin" ? 0 : storedUser.id;

// const adminId = storedUser.role === "admin" ? storedUser.id : storedUser.userId;

//     if (!adminId) {
//       alert("User ID missing!");

//       return;
//     }
//       try {
//         const res = await axios.get('https://botapi.emedha.in/pages/api/language-posts', {
//           params: { userId :adminId,  isAdmin },
//         });

//           const groupsData = res.data;

//       // Filter the groups based on the user role
//         // Filter the groups based on the user role
//       let filteredGroups;
//       if (storedUser.role === "admin") {
//         // Admin sees all groups, including empty role groups
//         filteredGroups = groupsData;
//       } else if (storedUser.role === "member") {
//         // Member only sees their own groups (where member_id matches)
//         filteredGroups = groupsData.filter(group => group.role === "member" && group.member_id === storedUser.id);
//       }

//         setPosts(filteredGroups);
//       } catch (err) {
//         console.error('Error fetching posts:', err);
//       }
//     };

//     fetchPosts();
//   }, [userId]);

//   const addPost1 = async () => {
//     if (!input) return;

//      const storedUser = JSON.parse(sessionStorage.getItem('user'));

//     if (!storedUser) {
//       alert('User not logged in');
  
//       return;
//     }
//       const role = storedUser.role;
//     const member_id = role === "admin" ? 0 : storedUser.id;


//     try {
//       const res = await axios.post('https://botapi.emedha.in/pages/api/language-posts', {
//         user_id: userId,
//         wa_id: waId,
//         language: input,
//         role:role,
//         member_id:member_id

//       });

//       setPosts([{ id: res.data.id, language: input }, ...posts]);
//       setInput('en_US');
//     } catch (err) {
//       console.error('Error adding post:', err);
//     }
//   };

//   const addPost = async () => {
//   if (!input) return;

//   const storedUser = JSON.parse(sessionStorage.getItem("user"));
//   if (!storedUser) {
//     alert("User not logged in");
//     return;
//   }

//   const role = storedUser.role;

//   // ✔ Correct role-based IDs
//   const user_id =
//     role === "admin" ? storedUser.id : storedUser.userId;

//   const member_id =
//     role === "admin" ? 0 : storedUser.id;

//   try {
//     const res = await axios.post(
//       "https://botapi.emedha.in/pages/api/language-posts",
//       {
//         user_id,
//         wa_id: waId,
//         language: input,
//         role,
//         member_id
//       }
//     );

//     setPosts([{ id: res.data.id, language: input }, ...posts]);
//     setInput("en_US");
//   } catch (err) {
//     console.error("Error adding post:", err);
//   }
// };


//   const deletePost = async (id) => {
//     try {
//       await axios.delete(`https://botapi.emedha.in/pages/api/language-posts/${id}`);
//       setPosts(posts.filter(post => post.id !== id));
//     } catch (err) {
//       console.error('Error deleting post:', err);
//     }
//   };

//   const startEdit = (post) => {
//     setEditId(post.id);
//     setEditInput(post.language);
//   };

//   const saveEdit = async () => {
//     try {
//       await axios.put(`https://botapi.emedha.in/pages/api/language-posts/${editId}`, {
//         user_id: userId,
//         wa_id: waId,
//         language: editInput,
//       });

//       setPosts(posts.map(post => post.id === editId ? { ...post, language: editInput } : post));
//       setEditId(null);
//       setEditInput('');
//     } catch (err) {
//       console.error('Error saving edit:', err);
//     }
//   };

//   return (
//     <div
//       style={{
//         fontFamily: 'Arial, sans-serif',
//         fontSize: '12px',
//         color: '#222',
//         maxWidth: 800,
//         padding: '1rem',
//       }}
//     >
//       <h4
//         style={{
//           textTransform: 'uppercase',
//           fontWeight: '700',
//           marginBottom: '1rem',
//           borderBottom: '1px solid #ccc',
//           paddingBottom: '0.5rem',
//         }}
//       >
//         LANGUAGE POSTS
//       </h4>

//       {/* Add Language Section */}
//       <div
//         style={{
//           display: 'flex',
//           alignItems: 'center',
//           gap: '0.75rem',
//           marginBottom: '1rem',
//           flexWrap: 'wrap',
//         }}
//       >
//         <label
//           htmlFor="language-select"
//           style={{ fontWeight: '600', textTransform: 'uppercase', minWidth: '110px' }}
//         >
//           Select Language:
//         </label>
//         <select
//           id="language-select"
//           value={input}
//           onChange={e => setInput(e.target.value)}
//           style={{
//             fontSize: '12px',
//             padding: '0.3rem 0.5rem',
//             border: '1px solid #ccc',
//             borderRadius: 0,
//             width: 200,
//             cursor: 'pointer',
//           }}
//         >
//           {languageOptions.map(lang => (
//             <option key={lang.code} value={lang.code}>
//               {lang.name}
//             </option>
//           ))}
//         </select>
//         <button
//           onClick={addPost}
//           style={{
//             fontSize: '12px',
//             padding: '0.3rem 1rem',
//             backgroundColor: '#007bff',
//             color: 'white',
//             border: 'none',
//             borderRadius: 0,
//             cursor: 'pointer',
//             fontWeight: '600',
//             textTransform: 'uppercase',
//           }}
//         >
//           Add
//         </button>
//       </div>

//       {/* Table */}
//       <div style={{ overflowX: 'auto' }}>
//         <table
//           style={{
//             width: '100%',
//             borderCollapse: 'collapse',
//             fontSize: '12px',
//           }}
//         >
//           <thead style={{ backgroundColor: '#f8f8f8', borderBottom: '1px solid #ccc' }}>
//             <tr>
//               <th
//                 style={{
//                   textAlign: 'left',
//                   padding: '0.5rem 0.75rem',
//                   textTransform: 'uppercase',
//                   borderBottom: '1px solid #ccc',
//                   width: '60%',
//                 }}
//               >
//                 Language
//               </th>
//               <th
//                 style={{
//                   textAlign: 'left',
//                   padding: '0.5rem 0.75rem',
//                   textTransform: 'uppercase',
//                   borderBottom: '1px solid #ccc',
//                   width: '40%',
//                 }}
//               >
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {posts.length === 0 ? (
//               <tr>
//                 <td
//                   colSpan="2"
//                   style={{ textAlign: 'center', padding: '1rem 0', color: '#999', fontStyle: 'italic' }}
//                 >
//                   No posts available.
//                 </td>
//               </tr>
//             ) : (
//               posts.map(post => (
//                 <tr key={post.id} style={{ borderBottom: '1px solid #eee' }}>
//                   <td style={{ padding: '0.5rem 0.75rem' }}>
//                     {editId === post.id ? (
//                       <select
//                         value={editInput}
//                         onChange={e => setEditInput(e.target.value)}
//                         style={{
//                           fontSize: '12px',
//                           padding: '0.3rem 0.5rem',
//                           border: '1px solid #ccc',
//                           borderRadius: 0,
//                           width: '100%',
//                           cursor: 'pointer',
//                         }}
//                       >
//                         {languageOptions.map(lang => (
//                           <option key={lang.code} value={lang.code}>
//                             {lang.name}
//                           </option>
//                         ))}
//                       </select>
//                     ) : (
//                       post.language
//                     )}
//                   </td>
//                   <td style={{ padding: '0.5rem 0.75rem' }}>
//                     {editId === post.id ? (
//                       <div style={{ display: 'flex', gap: '0.5rem' }}>
//                         <button
//                           onClick={saveEdit}
//                           style={{
//                             fontSize: '12px',
//                             padding: '0.3rem 0.75rem',
//                             backgroundColor: '#28a745',
//                             border: 'none',
//                             color: 'white',
//                             cursor: 'pointer',
//                             borderRadius: 0,
//                             fontWeight: '600',
//                             textTransform: 'uppercase',
//                           }}
//                         >
//                           Save
//                         </button>
//                         <button
//                           onClick={() => setEditId(null)}
//                           style={{
//                             fontSize: '12px',
//                             padding: '0.3rem 0.75rem',
//                             backgroundColor: '#6c757d',
//                             border: 'none',
//                             color: 'white',
//                             cursor: 'pointer',
//                             borderRadius: 0,
//                             fontWeight: '600',
//                             textTransform: 'uppercase',
//                           }}
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     ) : (
//                       <div style={{ display: 'flex', gap: '0.5rem' }}>
//                         <button
//                           onClick={() => startEdit(post)}
//                           style={{
//                             fontSize: '12px',
//                             padding: '0.3rem 0.75rem',
//                             backgroundColor: 'transparent',
//                             border: '1px solid #6c757d',
//                             color: '#6c757d',
//                             cursor: 'pointer',
//                             borderRadius: 0,
//                             fontWeight: '600',
//                             textTransform: 'uppercase',
//                           }}
//                         >
//                           Update
//                         </button>
//                         <button
//                           onClick={() => deletePost(post.id)}
//                           style={{
//                             fontSize: '12px',
//                             padding: '0.3rem 0.75rem',
//                             backgroundColor: 'transparent',
//                             border: '1px solid #dc3545',
//                             color: '#dc3545',
//                             cursor: 'pointer',
//                             borderRadius: 0,
//                             fontWeight: '600',
//                             textTransform: 'uppercase',
//                           }}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default Language;


// import React, { useState } from "react";
// import { Globe, Plus, Edit3, Trash2, ChevronLeft, ChevronRight } from "lucide-react";

// const languageLocales = [
//   "English (en_US)", "Hindi (hi_IN)", "French (fr_FR)", "Bengali (bn_IN)",
//   "Tamil (ta_IN)", "Telugu (te_IN)", "Marathi (mr_IN)", "Kannada (kn_IN)",
//   "Gujarati (gu_IN)", "Malayalam (ml_IN)", "Punjabi (pa_IN)", "Urdu (ur_IN)",
//   "Odia (or_IN)", "Spanish (es_ES)", "German (de_DE)", "Chinese (zh_CN)",
//   "Japanese (ja_JP)", "Russian (ru_RU)", "Arabic (ar_SA)", "Portuguese (pt_PT)",
//   "Italian (it_IT)", "Korean (ko_KR)"
// ];

// const activeLanguages = [
//   { locale: "te_IN" },
//   { locale: "en_US" },
//   { locale: "hi_IN" }
// ];

// export default function Language() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 2;

//   // Calculate dynamic pagination states
//   const totalItems = activeLanguages.length;
//   const totalPages = Math.ceil(totalItems / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
//   const currentItems = activeLanguages.slice(startIndex, endIndex);

//   return (
//     <div style={{ fontFamily: "sans-serif", padding: "24px", maxWidth: "1200px", margin: "0 auto", backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      
//       {/* HEADER SECTION */}
//       <div style={{ display: "flex", justifyContent: "between", alignItems: "center", flexWrap: "wrap", gap: "16px", marginBottom: "24px" }}>
//         <div>
//           <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#0f172a", margin: 0, display: "flex", alignItems: "center", gap: "8px" }}>
//             <Globe size={24} style={{ color: "#4f46e5" }} /> Language
//           </h1>
//           <p style={{ fontSize: "14px", color: "#64748b", marginTop: "4px", marginBottom: 0 }}>Configure supported bot languages</p>
//         </div>
//         <button style={{ display: "flex", alignItems: "center", gap: "6px", backgroundColor: "#4f46e5", color: "#ffffff", padding: "8px 16px", borderRadius: "8px", border: "none", fontSize: "14px", fontWeight: "500", cursor: "pointer" }}>
//           <Plus size={14} /> Add Language
//         </button>
//       </div>

//       {/* FORM CARD SECTION */}
//       <div style={{ backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #e2e8f0", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: "24px" }}>
//         <h2 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", marginTop: 0, marginBottom: "16px" }}>Language Posts</h2>
//         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "16px", alignItems: "end" }}>
//           <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//             <label style={{ fontSize: "13px", fontWeight: "500", color: "#475569" }}>Select Language <span style={{ color: "#ef4444" }}>*</span></label>
//             <select style={{ padding: "8px 12px", borderRadius: "8px", border: "1px solid #cbd5e1", backgroundColor: "#ffffff", fontSize: "14px", color: "#334155", outline: "none" }}>
//               {languageLocales.map((loc) => (
//                 <option key={loc} value={loc}>{loc}</option>
//               ))}
//             </select>
//           </div>
//           <div>
//             <button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", backgroundColor: "#4f46e5", color: "#ffffff", padding: "9px 16px", borderRadius: "8px", border: "none", fontSize: "14px", fontWeight: "500", cursor: "pointer", width: "100%" }}>
//               <Plus size={14} /> Add
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* DISPLAY LIST SECTION */}
//       <div style={{ backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", overflow: "hidden" }}>
        
//         {/* Table Header */}
//         <div style={{ padding: "14px 20px", borderBottom: "1px solid #e2e8f0", backgroundColor: "#f8fafc" }}>
//           <p style={{ margin: 0, fontSize: "12px", fontWeight: "600", color: "#475569", letterSpacing: "0.05em", textTransform: "uppercase" }}>
//             Language Actions
//           </p>
//         </div>
        
//         {/* List Content */}
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           {currentItems.map((lang, index) => (
//             <div 
//               key={lang.locale} 
//               style={{ 
//                 display: "flex", 
//                 justifyContent: "space-between", 
//                 alignItems: "center", 
//                 padding: "16px 20px", 
//                 gap: "12px",
//                 flexWrap: "wrap",
//                 borderBottom: index !== currentItems.length - 1 ? "1px solid #e2e8f0" : "none"
//               }}
//             >
//               {/* Left Side Info Area */}
//               <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                 <div style={{ width: "40px", height: "40px", borderRadius: "12px", backgroundColor: "#eef2ff", border: "1px solid #e0e7ff", display: "flex", alignItems: "center", justifyItems: "center", justifyContent: "center", color: "#4f46e5", fontSize: "12px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.05em" }}>
//                   {lang.locale.split('_')[0]}
//                 </div>
//                 <div>
//                   <p style={{ margin: 0, fontSize: "14px", fontWeight: "600", color: "#0f172a", fontFamily: "monospace" }}>
//                     {lang.locale}
//                   </p>
//                   <p style={{ margin: "2px 0 0 0", fontSize: "12px", color: "#94a3b8" }}>
//                     Bot localization identifier
//                   </p>
//                 </div>
//               </div>

//               {/* Right Side Action Triggers */}
//               <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <button style={{ display: "flex", alignItems: "center", gap: "6px", padding: "6px 12px", fontSize: "12px", fontWeight: "500", borderRadius: "8px", border: "1px solid #e2e8f0", backgroundColor: "#ffffff", color: "#334155", cursor: "pointer" }}>
//                   <Edit3 size={13} />
//                   <span>Update</span>
//                 </button>
//                 <button style={{ display: "flex", alignItems: "center", gap: "6px", padding: "6px 12px", fontSize: "12px", fontWeight: "500", borderRadius: "8px", border: "1px solid #fee2e2", backgroundColor: "#ffffff", color: "#ef4444", cursor: "pointer" }}>
//                   <Trash2 size={13} />
//                   <span>Delete</span>
//                 </button>
//               </div>

//             </div>
//           ))}
//         </div>

//         {/* RESPONSIVE PAGINATION INTERFACE */}
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px", padding: "16px", borderTop: "1px solid #e2e8f0", backgroundColor: "#f8fafc" }}>
//           <div style={{ fontSize: "12px", color: "#64748b" }}>
//             Showing <span style={{ fontWeight: "600", color: "#1e293b" }}>{totalItems === 0 ? 0 : startIndex + 1}</span> to{" "}
//             <span style={{ fontWeight: "600", color: "#1e293b" }}>{endIndex}</span> of{" "}
//             <span style={{ fontWeight: "600", color: "#1e293b" }}>{totalItems}</span> entries
//           </div>

//           <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//             <button
//               onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//               disabled={currentPage === 1}
//               style={{ padding: "6px", border: "1px solid #e2e8f0", borderRadius: "8px", backgroundColor: "#ffffff", color: "#475569", cursor: currentPage === 1 ? "not-allowed" : "pointer", opacity: currentPage === 1 ? 0.4 : 1, display: "flex", alignItems: "center" }}
//             >
//               <ChevronLeft size={16} />
//             </button>
            
//             {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//               <button
//                 key={page}
//                 onClick={() => setCurrentPage(page)}
//                 style={{
//                   padding: "6px 12px",
//                   fontSize: "12px",
//                   fontWeight: "500",
//                   borderRadius: "8px",
//                   border: page === currentPage ? "none" : "1px solid #e2e8f0",
//                   backgroundColor: page === currentPage ? "#4f46e5" : "#ffffff",
//                   color: page === currentPage ? "#ffffff" : "#475569",
//                   cursor: "pointer",
//                   boxShadow: page === currentPage ? "0 1px 2px rgba(0,0,0,0.05)" : "none"
//                 }}
//               >
//                 {page}
//               </button>
//             ))}

//             <button
//               onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
//               disabled={currentPage === totalPages}
//               style={{ padding: "6px", border: "1px solid #e2e8f0", borderRadius: "8px", backgroundColor: "#ffffff", color: "#475569", cursor: currentPage === totalPages ? "not-allowed" : "pointer", opacity: currentPage === totalPages ? 0.4 : 1, display: "flex", alignItems: "center" }}
//             >
//               <ChevronRight size={16} />
//             </button>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import axios from "axios";
import { Globe, Plus, Edit3, Trash2, ChevronLeft, ChevronRight, Save, X } from "lucide-react";

const Language = () => {
  const [posts, setPosts] = useState([]);
  const [input, setInput] = useState("en_US");
  const [editId, setEditId] = useState(null);
  const [editInput, setEditInput] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // You can adjust this to your liking (e.g., 5 or 10)

  const user = JSON.parse(sessionStorage.getItem("user")) || {};
  const userId = user.id || "";
  const isAdmin = false;

  const languageOptions = [
    { code: "en_US", name: "English (en_US)" },
    { code: "hi_IN", name: "Hindi (hi_IN)" },
    { code: "fr_FR", name: "French (fr_FR)" },
    { code: "bn_IN", name: "Bengali (bn_IN)" },
    { code: "ta_IN", name: "Tamil (ta_IN)" },
    { code: "te_IN", name: "Telugu (te_IN)" },
    { code: "mr_IN", name: "Marathi (mr_IN)" },
    { code: "kn_IN", name: "Kannada (kn_IN)" },
    { code: "gu_IN", name: "Gujarati (gu_IN)" },
    { code: "ml_IN", name: "Malayalam (ml_IN)" },
    { code: "pa_IN", name: "Punjabi (pa_IN)" },
    { code: "ur_IN", name: "Urdu (ur_IN)" },
    { code: "or_IN", name: "Odia (or_IN)" },
    { code: "es_ES", name: "Spanish (es_ES)" },
    { code: "de_DE", name: "German (de_DE)" },
    { code: "zh_CN", name: "Chinese (zh_CN)" },
    { code: "ja_JP", name: "Japanese (ja_JP)" },
    { code: "ru_RU", name: "Russian (ru_RU)" },
    { code: "ar_SA", name: "Arabic (ar_SA)" },
    { code: "pt_PT", name: "Portuguese (pt_PT)" },
    { code: "it_IT", name: "Italian (it_IT)" },
    { code: "ko_KR", name: "Korean (ko_KR)" },
  ];

  const [waId, setWaId] = useState(null);
  const [templateOptions, setTemplateOptions] = useState([]);

  /* ---------------------------
     1️⃣  GET WA_ID BASED ON ROLE
  ----------------------------*/
  useEffect(() => {
    const loggedUser = JSON.parse(sessionStorage.getItem("user"));
    if (!loggedUser) return;

    const emailToUse =
      loggedUser.role === "admin"
        ? loggedUser.email // admin → use own email
        : loggedUser.adminEmail; // member → use admin's email

    if (!emailToUse) return;

    axios
      .get(
        `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
          emailToUse
        )}`
      )
      .then((response) => {
        const userData = response.data;
        console.log("User Data Fetched:", userData);

        if (userData?.wa_id) {
          setWaId(userData.wa_id);
        }
      })
      .catch((err) => {
        console.error("Error retrieving user data:", err);
      });
  }, []);

  /* ---------------------------
     2️⃣  FETCH POSTS
  ----------------------------*/
  useEffect(() => {
    if (!userId) return;

    const fetchPosts = async () => {
      const storedUser = JSON.parse(sessionStorage.getItem("user"));

      if (!storedUser) {
        alert("User not logged in");
        return;
      }
      const role = storedUser.role;
      const member_id = role === "admin" ? 0 : storedUser.id;
      const adminId = storedUser.role === "admin" ? storedUser.id : storedUser.userId;

      if (!adminId) {
        alert("User ID missing!");
        return;
      }
      try {
        const res = await axios.get("https://botapi.emedha.in/pages/api/language-posts", {
          params: { userId: adminId, isAdmin },
        });

        const groupsData = res.data;

        let filteredGroups;
        if (storedUser.role === "admin") {
          filteredGroups = groupsData;
        } else if (storedUser.role === "member") {
          filteredGroups = groupsData.filter(
            (group) => group.role === "member" && group.member_id === storedUser.id
          );
        }

        setPosts(filteredGroups);
      } catch (err) {
        console.error("Error fetching posts:", err);
      }
    };

    fetchPosts();
  }, [userId]);

  /* ---------------------------
     3️⃣  ACTIONS
  ----------------------------*/
  const addPost = async () => {
    if (!input) return;

    const storedUser = JSON.parse(sessionStorage.getItem("user"));
    if (!storedUser) {
      alert("User not logged in");
      return;
    }

    const role = storedUser.role;
    const user_id = role === "admin" ? storedUser.id : storedUser.userId;
    const member_id = role === "admin" ? 0 : storedUser.id;

    try {
      const res = await axios.post("https://botapi.emedha.in/pages/api/language-posts", {
        user_id,
        wa_id: waId,
        language: input,
        role,
        member_id,
      });

      setPosts([{ id: res.data.id, language: input }, ...posts]);
      setInput("en_US");
      setCurrentPage(1); // Return to first page to see the added post
    } catch (err) {
      console.error("Error adding post:", err);
    }
  };

  const deletePost = async (id) => {
    try {
      await axios.delete(`https://botapi.emedha.in/pages/api/language-posts/${id}`);
      const updatedPosts = posts.filter((post) => post.id !== id);
      setPosts(updatedPosts);
      
      // Dynamic fix for tracking empty pages when items are deleted
      const maxPages = Math.ceil(updatedPosts.length / itemsPerPage);
      if (currentPage > maxPages && maxPages > 0) {
        setCurrentPage(maxPages);
      }
    } catch (err) {
      console.error("Error deleting post:", err);
    }
  };

  const startEdit = (post) => {
    setEditId(post.id);
    setEditInput(post.language);
  };

  const saveEdit = async () => {
    try {
      await axios.put(`https://botapi.emedha.in/pages/api/language-posts/${editId}`, {
        user_id: userId,
        wa_id: waId,
        language: editInput,
      });

      setPosts(
        posts.map((post) => (post.id === editId ? { ...post, language: editInput } : post))
      );
      setEditId(null);
      setEditInput("");
    } catch (err) {
      console.error("Error saving edit:", err);
    }
  };

  // Dynamic Pagination Calculations
  const totalItems = posts.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const currentItems = posts.slice(startIndex, endIndex);

  return (
    <div
      style={{
        fontFamily: "sans-serif",
        padding: "24px",
        maxWidth: "1200px",
        margin: "0 auto",
        backgroundColor: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      {/* HEADER SECTION */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "16px",
          marginBottom: "24px",
        }}
      >
        <div>
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "700",
              color: "#0f172a",
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Globe size={24} style={{ color: "#4f46e5" }} /> Language
          </h1>
          <p style={{ fontSize: "14px", color: "#64748b", marginTop: "4px", marginBottom: 0 }}>
            Configure supported bot languages
          </p>
        </div>
      </div>

      {/* FORM CARD SECTION */}
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          padding: "20px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          marginBottom: "24px",
        }}
      >
        <h2
          style={{
            fontSize: "16px",
            fontWeight: "600",
            color: "#1e293b",
            marginTop: 0,
            marginBottom: "16px",
          }}
        >
          Language Posts
        </h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "16px",
            alignItems: "end",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label
              htmlFor="language-select"
              style={{ fontSize: "13px", fontWeight: "500", color: "#475569" }}
            >
              Select Language <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <select
              id="language-select"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              style={{
                padding: "8px 12px",
                borderRadius: "8px",
                border: "1px solid #cbd5e1",
                backgroundColor: "#ffffff",
                fontSize: "14px",
                color: "#334155",
                outline: "none",
                cursor: "pointer",
              }}
            >
              {languageOptions.map((lang) => (
                <option key={lang.code} value={lang.code}>
                  {lang.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <button
              onClick={addPost}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                backgroundColor: "#4f46e5",
                color: "#ffffff",
                padding: "9px 16px",
                borderRadius: "8px",
                border: "none",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
                width: "100%",
              }}
            >
              <Plus size={14} /> Add
            </button>
          </div>
        </div>
      </div>

      {/* DISPLAY LIST SECTION */}
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          overflow: "hidden",
        }}
      >
        {/* Table Header */}
        <div
          style={{
            padding: "14px 20px",
            borderBottom: "1px solid #e2e8f0",
            backgroundColor: "#f8fafc",
          }}
        >
          <p
            style={{
              margin: 0,
              fontSize: "12px",
              fontWeight: "600",
              color: "#475569",
              letterSpacing: "0.05em",
              textTransform: "uppercase",
          }}
          >
            Language Actions
          </p>
        </div>

        {/* List Content */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          {currentItems.length === 0 ? (
            <div style={{ padding: "32px", textAlign: "center", color: "#94a3b8", fontSize: "14px", fontStyle: "italic" }}>
              No posts available.
            </div>
          ) : (
            currentItems.map((post, index) => (
              <div
                key={post.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "16px 20px",
                  gap: "12px",
                  flexWrap: "wrap",
                  borderBottom: index !== currentItems.length - 1 ? "1px solid #e2e8f0" : "none",
                }}
              >
                {/* Left Side Info Area */}
                <div style={{ display: "flex", alignItems: "center", gap: "12px", flex: 1, minWidth: "250px" }}>
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "12px",
                      backgroundColor: "#eef2ff",
                      border: "1px solid #e0e7ff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#4f46e5",
                      fontSize: "12px",
                      fontWeight: "700",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}
                  >
                    {post.language ? post.language.split("_")[0] : "??"}
                  </div>
                  
                  <div style={{ flex: 1 }}>
                    {editId === post.id ? (
                      <select
                        value={editInput}
                        onChange={(e) => setEditInput(e.target.value)}
                        style={{
                          padding: "6px 10px",
                          borderRadius: "8px",
                          border: "1px solid #4f46e5",
                          backgroundColor: "#ffffff",
                          fontSize: "14px",
                          color: "#334155",
                          outline: "none",
                          width: "100%",
                          maxWidth: "250px",
                        }}
                      >
                        {languageOptions.map((lang) => (
                          <option key={lang.code} value={lang.code}>
                            {lang.name}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#0f172a",
                            fontFamily: "monospace",
                          }}
                        >
                          {post.language}
                        </p>
                        <p style={{ margin: "2px 0 0 0", fontSize: "12px", color: "#94a3b8" }}>
                          Bot localization identifier
                        </p>
                      </>
                    )}
                  </div>
                </div>

                {/* Right Side Action Triggers */}
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  {editId === post.id ? (
                    <>
                      <button
                        onClick={saveEdit}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          padding: "6px 12px",
                          fontSize: "12px",
                          fontWeight: "500",
                          borderRadius: "8px",
                          border: "1px solid #22c55e",
                          backgroundColor: "#f0fdf4",
                          color: "#16a34a",
                          cursor: "pointer",
                        }}
                      >
                        <Save size={13} />
                        <span>Save</span>
                      </button>
                      <button
                        onClick={() => setEditId(null)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          padding: "6px 12px",
                          fontSize: "12px",
                          fontWeight: "500",
                          borderRadius: "8px",
                          border: "1px solid #cbd5e1",
                          backgroundColor: "#ffffff",
                          color: "#64748b",
                          cursor: "pointer",
                        }}
                      >
                        <X size={13} />
                        <span>Cancel</span>
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => startEdit(post)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          padding: "6px 12px",
                          fontSize: "12px",
                          fontWeight: "500",
                          borderRadius: "8px",
                          border: "1px solid #e2e8f0",
                          backgroundColor: "#ffffff",
                          color: "#334155",
                          cursor: "pointer",
                        }}
                      >
                        <Edit3 size={13} />
                        <span>Update</span>
                      </button>
                      <button
                        onClick={() => deletePost(post.id)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          padding: "6px 12px",
                          fontSize: "12px",
                          fontWeight: "500",
                          borderRadius: "8px",
                          border: "1px solid #fee2e2",
                          backgroundColor: "#ffffff",
                          color: "#ef4444",
                          cursor: "pointer",
                        }}
                      >
                        <Trash2 size={13} />
                        <span>Delete</span>
                      </button>
                    </>
                  )}
                </div>

              </div>
            ))
          )}
        </div>

        {/* RESPONSIVE PAGINATION INTERFACE */}
        {totalItems > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "16px",
              padding: "16px",
              borderTop: "1px solid #e2e8f0",
              backgroundColor: "#f8fafc",
            }}
          >
            <div style={{ fontSize: "12px", color: "#64748b" }}>
              Showing <span style={{ fontWeight: "600", color: "#1e293b" }}>{startIndex + 1}</span> to{" "}
              <span style={{ fontWeight: "600", color: "#1e293b" }}>{endIndex}</span> of{" "}
              <span style={{ fontWeight: "600", color: "#1e293b" }}>{totalItems}</span> entries
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={{
                  padding: "6px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  backgroundColor: "#ffffff",
                  color: "#475569",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  opacity: currentPage === 1 ? 0.4 : 1,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ChevronLeft size={16} />
              </button>

              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  style={{
                    padding: "6px 12px",
                    fontSize: "12px",
                    fontWeight: "500",
                    borderRadius: "8px",
                    border: page === currentPage ? "none" : "1px solid #e2e8f0",
                    backgroundColor: page === currentPage ? "#4f46e5" : "#ffffff",
                    color: page === currentPage ? "#ffffff" : "#475569",
                    cursor: "pointer",
                    boxShadow: page === currentPage ? "0 1px 2px rgba(0,0,0,0.05)" : "none",
                  }}
                >
                  {page}
                </button>
              ))}

              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                style={{
                  padding: "6px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  backgroundColor: "#ffffff",
                  color: "#475569",
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  opacity: currentPage === totalPages ? 0.4 : 1,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ChevronRight size={16} />
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default Language;